/**
 * Created by stonewang on 2017/8/15.
 */
import React from 'react';
import { hashHistory } from 'react-router'
import { Button, Table, message, Modal } from 'antd';
import { DmsTab, DataList, RemarkModal, UploadFile } from 'Components';
import { config } from 'Utils';
import { sellerDetail, openAccount } from '../../service/store/staff';
import { accountResetPwd, accountInvalid } from '../../service/account';
import { getList as getRemarkList, deleteRemarks } from '../../service/remark/remark';
import { getList as getFileList, deleteFiles, addFileDownCount } from '../../service/remark/file';
const confirm = Modal.confirm;

class StaffDetail extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      staffId: this.props.params.staffId,
      storeId: this.props.params.storeId,
      detail: {},
      accounts: [],
      remarks: [],
      files: [],
      fileTotal: 0,
      accountTotal: 0,
      remarkTotal: 0,
    }
    this.getFiles = this.getFiles.bind(this);
    this.getDetail = this.getDetail.bind(this);
    this.getRemarks = this.getRemarks.bind(this);
  }
  componentDidMount () {
    this.getFiles();
    this.getDetail();
    this.getRemarks();
  }
  goView (url) {
    hashHistory.push(url);
  }
  goBack () {
    hashHistory.goBack();
  }
  openModal() {
    this.remarkModal.showModal();
  }
  getDetail () {
    const self = this;
    sellerDetail(self.state.staffId).then(res => {
      self.setState({
        ...this.state,
        accounts: res.data.dmsSellerVo.dmsUser ? [res.data.dmsSellerVo.dmsUser] : [],
        detail: res.data.dmsSellerVo
      })
    })
  }

  getRemarks () {
    const self = this;
    getRemarkList({ relatedTableType: 4, relatedTableId: self.state.staffId, p: 1, s: 5 }).then(res => {
      self.setState({
        ...this.state,
        remarks: res.data,
        remarkTotal: res.total
      })
    })
  }

  deleteRemark (id) {
    const self = this;
    confirm({
      title: '确定要删除这条记录?',
      //content: 'Some descriptions',
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      onOk() {
        deleteRemarks({ id }).then(res => {
          message[res.status ? 'success' : 'error'](res.message);
          res.status && self.getRemarks();
        })
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  getFiles () {
    const self = this;
    getFileList({ dealType: 4, id: self.state.staffId, p: 1, s: 5 }).then(res => {
      self.setState({
        ...this.state,
        files: res.data,
        fileTotal: res.total
      })
    })
  }

  deleteFile (id) {
    const self = this;
    confirm({
      title: '确定要删除附件?',
      //content: 'Some descriptions',
      okText: '确定',
      okType: 'danger',
      cancelText: '取消',
      onOk() {
        deleteFiles({ ids: [id] }).then(res => {
          message[res.status ? 'success' : 'error'](res.message);
          res.status && self.getFiles();
        })
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  downCount (id) {
    const self = this;
    addFileDownCount({ id }).then(res => {
      message[res.status ? 'success' : 'error'](res.message);
      res.status && self.getFiles();
    })
  }
  createAccount(staffId){
    const self = this;
    openAccount({sellerId: staffId}).then(res => {
      message[res.status ? 'success' : 'error'](res.message);
      res.status && self.getDetail();
    })
  }
  invalidAccount(accountId){

    const self = this;
    accountInvalid({id: accountId}).then(res => {
      message[res.status ? 'success' : 'error'](res.message);
      res.status && self.getDetail();
    })
  }
  resetPwd(accountId){

    const self = this;
    accountResetPwd({id: accountId}).then(res => {
      message[res.status ? 'success' : 'error'](res.message);
      res.status && self.getDetail();
    })
  }
  render () {
    const self = this;
    const { detail, staffId, storeId, accounts, files, remarks, fileTotal, remarkTotal } = this.state;
    const cells = {
      name: {
        title: '姓名',
      },
      sexText: {
        title: '性别',
      },
      mobileText: {
        title: '手机',
      },
      storeName: {
        title: '公司',
      },
      /*dept: {
        title: '部门',
      },*/
      postText: {
        title: '岗位',
      },
      phoneText: {
        title: '座机',
      },
      emailText: {
        title: 'Email',
      },
      qqText: {
        title: 'QQ',
      },
      weiText: {
        title: '微信',
      },
      createdDate: {
        title: '创建时间',
        render: text => text ? new Date(text).format('yyyy-MM-dd hh:mm') : '----'
      },
      lastUpdatedDate: {
        title: '最后更新',
        render: text => text ? new Date(text).format('yyyy-MM-dd hh:mm') : '----'
      }
    };
    const accountProps = {
      rowKey: 'id',
      columns: [
        {
          title: '账号',
          dataIndex: 'account',
        },
        {
          title: '状态',
          dataIndex: 'status',
          render: (text, record, index) => {
            //0-禁用；1-启用；2-待审核
            if(text == 0) return '禁用';
            if(text == 1) return '启用';
            if(text == 2) return '待审核';
            return '';
          }
        },
        {
          title: '开通时间',
          dataIndex: 'createdDate',
          render: (text, record, index) => {
            if(record.auditDate){
              return record.auditDate
            }else{
              return text
            }
          }
        },
        {
          title: '上一次登录',
          dataIndex: 'lastLoginDate',
          render: (text) => text || '----'
        },
        {
          title: '操作',
          dataIndex: '',
          render: (text, record, index) => <span>
            <a onClick={self.invalidAccount.bind(self, record.id)}>禁用账号</a>&nbsp;&nbsp;&nbsp;
            <a onClick={self.resetPwd.bind(self, record.id)}>重置密码</a>
          </span>
        },
      ],
      dataSource: accounts
    };
    const fileProps = {
      rowKey: 'id',
      columns: [
        {
          title: '标题',
          dataIndex: 'fileName',
        },
        {
          title: '创建时间',
          dataIndex: 'createdDate',
          render: (text) => new Date(text).format('yyyy-MM-dd hh:mm')
        },
        {
          title: '下载次数',
          dataIndex: 'downloadCount',
        },
        {
          title: '类型',
          dataIndex: 'extension',
        },
        {
          title: '大小',
          dataIndex: 'size',
          render: (text, record, index) => text.bytesToSize()
        },
        {
          title: '操作',
          dataIndex: 'fileId',
          render: (text, record, index) => <span>
            <a href={`${config.server}/api/v1/dms/commonAttachUpload/getFileDown?id=${text}`}
               onClick={this.downCount.bind(self, text)}>下载</a>&nbsp;&nbsp;&nbsp;
            <a onClick={this.deleteFile.bind(self, text)}>删除</a>
          </span>
        },
      ],
      dataSource: files
    };
    const remarkProps = {
      rowKey: 'id',
      columns: [
        {
          title: '主题',
          dataIndex: 'content',
        },
        {
          title: '创建时间',
          dataIndex: 'createdDate',
        },
        {
          title: '操作',
          dataIndex: '',
          render: (text, record, index) => <span><a onClick={self.deleteRemark.bind(self, record.id)}>删除</a></span>
        },
      ],
      dataSource: remarks
    };
    return <div className="dms-main-box">
      <div>
        <DmsTab options={['员工详情']} defaultKey={0}>
          <Button onClick={this.goView.bind(this, `/staff/${storeId}/add/${detail.id}`)}>编辑</Button>
          <Button onClick={this.goBack}>返回</Button>
        </DmsTab>
        <div className="dms-table-box">
          <div className="dms-detail-brief-box">
            <img className="store-logo" alt="员工头像" src={detail.dmsUser && detail.dmsUser.photoUrl ? config.server+detail.dmsUser.photoUrl : require('../../assets/images/ic-dy-man03.png')} />
            <div className="brief">
              <p><span className="dms-black">姓名</span><span className="dms-light-gray">{detail.name || '----'}</span></p>
              <p><span className="dms-black">性别</span><span className="dms-light-gray">{detail.sexText || '----'}</span></p>
              <p><span className="dms-black">手机</span><span className="dms-light-gray">{detail.mobileText || '----'}</span></p>
            </div>
          </div>
          <DataList cells={cells} data={detail}></DataList>
        </div>
      </div>
      <div>
        <DmsTab className="white-bg no-border" options={['账号']} defaultKey={0}>
          {
            accounts.length===0 ? <Button type="primary" onClick={this.createAccount.bind(this, detail.id)}>开通账号</Button> : null
          }
        </DmsTab>
        <div className="dms-table-box">
          <Table {...accountProps} bordered pagination={false}/>
        </div>
      </div>
      <div className="dms-split-bar"></div>
      <div>
        <DmsTab className="white-bg no-border" options={['附件']} defaultKey={0}>
          <UploadFile color="red"
                      entityType="staff"
                      entityId={staffId}
                      onSuccess={this.getFiles}/>
        </DmsTab>
        <div className="dms-table-box">
          <Table {...fileProps} bordered pagination={false}/>
          <br />
          {!!fileTotal &&
          <p><a onClick={this.goView.bind(this, `/file?entityId=${staffId}&entityType=staff`)}>查看全部（{fileTotal}）</a>
          </p>}
        </div>
      </div>
      <div className="dms-split-bar"></div>
      <div>
        <DmsTab className="white-bg no-border" options={['备注']} defaultKey={0}>
          <Button type="primary" onClick={this.openModal.bind(this)}>新建备注</Button>
        </DmsTab>
        <div className="dms-table-box">
          <Table {...remarkProps} bordered pagination={false}/>
          <br />
          {!!remarkTotal &&
          <p><a onClick={this.goView.bind(this, `/remark?entityId=${staffId}&entityType=staff`)}>查看全部（{remarkTotal}）</a>
          </p>}
        </div>
      </div>
      <RemarkModal ref={(node) => { this.remarkModal = node; }}
                   entityType="staff"
                   entityId={staffId}
                   onSuccess={this.getRemarks}/>
    </div>
  }
};
export default StaffDetail;


// WEBPACK FOOTER //
// ./src/routes/staff/detail.js